class CartReservation extends HTMLElement {
  constructor() {
    super();
    this.interval = null;
    this.runningElement = null;
    this.endedElement = null;
    this.timerElement = null;
    this.container = null;
    this.expiresAt = null;
  }

  connectedCallback() {
    this.runningElement = this.querySelector('[data-ref="running"]');
    this.endedElement = this.querySelector('[data-ref="ended"]');
    this.timerElement = this.querySelector('[data-ref="timer"]');
    this.container = this.closest('.cart-reservation');

    if (!this.container || !this.runningElement || !this.endedElement || !this.timerElement) return;

    const cartItemCount = Number.parseInt(this.dataset.cartItemCount || '0', 10);
    const isPreviewMode = this.container.hasAttribute('data-visual-preview-mode');

    if (cartItemCount <= 0) {
      this.#clearReservation();

      if (!isPreviewMode) {
        this.container.classList.add('hidden');
        return;
      }

      this.#showRunning();
      this.timerElement.textContent = this.#formatDuration();
      return;
    }

    this.container.classList.remove('hidden');

    this.expiresAt = this.#getStoredExpiration();
    if (!this.expiresAt) {
      this.expiresAt = Date.now() + this.#getDurationInMs();
      this.#storeExpiration(this.expiresAt);
    }

    this.#updateCountdown();

    if (this.expiresAt > Date.now()) {
      this.interval = window.setInterval(() => this.#updateCountdown(), 1000);
    }
  }

  disconnectedCallback() {
    this.#clearInterval();
  }

  #getStorageKey() {
    const cartToken = this.dataset.cartToken || 'default';
    return `fs-cart-reservation-${cartToken}`;
  }

  #getDurationInMs() {
    const durationMinutes = Number.parseInt(this.dataset.durationMinutes || '10', 10);
    const normalizedDuration = Number.isNaN(durationMinutes) ? 10 : durationMinutes;
    return normalizedDuration * 60 * 1000;
  }

  #formatDuration() {
    const totalSeconds = Math.floor(this.#getDurationInMs() / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  #getStoredExpiration() {
    const storedValue = localStorage.getItem(this.#getStorageKey());
    if (!storedValue) return null;

    const expiration = Number.parseInt(storedValue, 10);
    if (Number.isNaN(expiration)) return null;

    return expiration;
  }

  #storeExpiration(expiration) {
    localStorage.setItem(this.#getStorageKey(), `${expiration}`);
  }

  #clearReservation() {
    localStorage.removeItem(this.#getStorageKey());
    this.#clearInterval();
  }

  #clearInterval() {
    if (!this.interval) return;
    window.clearInterval(this.interval);
    this.interval = null;
  }

  #updateCountdown() {
    if (!this.expiresAt) return;

    const remainingMs = this.expiresAt - Date.now();
    if (remainingMs <= 0) {
      this.#showEnded();
      this.#clearInterval();
      return;
    }

    const totalSeconds = Math.floor(remainingMs / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    this.timerElement.textContent = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    this.#showRunning();
  }

  #showRunning() {
    this.runningElement.classList.remove('hidden');
    this.endedElement.classList.add('hidden');
  }

  #showEnded() {
    if (this.dataset.endedStyle === 'hide_block') {
      this.container.classList.add('hidden');
      return;
    }

    this.runningElement.classList.add('hidden');
    this.endedElement.classList.remove('hidden');
  }
}

if (!customElements.get('cart-reservation')) {
  customElements.define('cart-reservation', CartReservation);
}
